/**
 * Labels of the shared customer filter configuration.
 *
 * They live in the global catalog because `utils/customerFilters.js` is used by
 * several components (the customer list, the campaign recipients modal) which
 * must show exactly the same wording.
 */

export const customerFiltersMessagesEn = {
    customerFilters: {
        customerType: "Customer type",
        company: "Company",
        individual: "Individual",
        businessActivity: "Business activity",
        geographicZone: "Geographic zone",
        incompleteBillingAddress: "Incomplete billing address",
        noCatalogAssigned: "No catalog assigned",
        prospects: "Prospects",
    },
};

export const customerFiltersMessagesFr = {
    customerFilters: {
        customerType: "Type de client",
        company: "Société",
        individual: "Particulier",
        businessActivity: "Activité du client",
        geographicZone: "Zone géographique",
        incompleteBillingAddress: "Adresse de facturation incomplète",
        noCatalogAssigned: "Aucun catalogue assigné",
        prospects: "Prospects",
    },
};
